/** @format */

import React, { useContext } from "react";
import { mainDataArray } from "./Fields";
import { InventoryDocContext } from "../Contex";
import { FieldsReducer } from "./../../../../CommonComponents/Reducer/Index";

export default function MainTab(props) {
  const { onChange, operation, dropDowns, _invDocData } =
    useContext(InventoryDocContext);

  const mergedFieldData = (field) => {
    let newFieldObject = { ...field, dataSource: _invDocData, onChange };
    switch (operation) {
      case "Display":
        newFieldObject.disabled = true;
        break;
      case "Change":
        if (newFieldObject.key) {
          newFieldObject.disabled = true;
        }
        if (newFieldObject.displayOnly) {
          newFieldObject.disabled = true;
        }
        break;
      case "Create":
        if (newFieldObject.displayOnly) {
          newFieldObject.disabled = true;
        }
        break;
      default:
    }

    return newFieldObject;
  };
  const fieldsState = {
    dropDowns,
  };

  const mainToRender = mainDataArray(fieldsState);

  return (
    <div className="row">
      <div className="col-lg-3 col-sm-6 col-xs-12">
        <div className="card">
          <div className="cardHeader">
            <h2>Admin</h2>
          </div>
          <div className="cardBody">
            {mainToRender.map((field, index) => (
              <FieldsReducer field={mergedFieldData(field)} key={index} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
